import { ReactElement, ReactNode } from 'react';
import { styled } from 'styled-components';
import layoutStyle from '../../../../../components/styles/Layout';

const Layout = styled.div`
  ${layoutStyle}
  display: grid;
  grid-template-rows: min-content min-content;
  gap: 16px;
`;

interface Props {
  header: ReactNode;
  body: ReactNode;
}

const ContentBodyLayout = ({ header, body }: Props): ReactElement => (
  <Layout>
    {header}
    {body}
  </Layout>
);

export default ContentBodyLayout;
